module.exports = __webpack_public_path__ + "static/img/base_three.dbd8f11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/base_three.png
// module id = e8x5
// module chunks = 1